import { Component, Input, ViewChild } from '@angular/core';
import { CustomInputComponent } from 'components/input/custom-input/custom-input.component';
import { SubmitButtonComponent } from 'components/input/submit-button/submit-button.component';
import { InputType } from 'enums/InputType';
import { TaskActionType } from 'enums/TaskActionType';
import { TaskflowStatus } from 'enums/TaskflowStatus';
import { OrderLineModel } from 'models/generated/Entities.GormCrm.OrderLine';
import { TaskActionModel } from 'models/generated/Entities.GormCrm.TaskAction';
import { TranslatePipe } from 'pipes/translate.pipe';
import { ComponentUrl } from 'services/navigation.service';
import { SalesService } from 'services/sales.service';

@Component({
	selector: 'product-launch-view',
	styleUrls: ['./product-launch-view.component.scss'],
	templateUrl: './product-launch-view.component.html',
	imports: [CustomInputComponent, SubmitButtonComponent, TranslatePipe]
})
@ComponentUrl('product-launch-view')
export class ProductLaunchViewComponent {

	@ViewChild('sendInvoiceButton') sendInvoiceButton?: SubmitButtonComponent;

	inputTypeEnum = InputType;

	private _taskAction?: TaskActionModel;
	orderLines: OrderLineModel[] = [];
	
	@Input()
	set taskAction(action: TaskActionModel | undefined) {
		this.orderLines = [];
		if (action == undefined) return;

		this._taskAction = action;
		this.orderLines = [];
		//this.orderLines = action!.taskflow!.taskflowProducts.map(tp => tp.orderLine!);
		this.orderLines.forEach(orderLine => orderLine.sendInvoice = orderLine!.invoiced != null);
	}
	get taskAction() {
		return this._taskAction;
	}

	constructor(private readonly saleService: SalesService, private translate: TranslatePipe) {
	}

	readyForLaunch(orderLine: OrderLineModel): boolean {
		return false;
		/*const openQualificationCall = this.taskAction!.taskflow!.taskActions.some(
			taskAction => taskAction.type == TaskActionType.qualificationCall &&
			taskAction.completed == undefined);
		const openSubflows = this.taskAction!.taskflow!.subTaskflows.some(
			subTaskflow => subTaskflow.status != TaskflowStatus.Completed &&
				subTaskflow.stepOnParent! <= this.taskAction!.step &&
				subTaskflow.taskflowProducts.some(tp => tp.orderLine!.id === orderLine.id));
		return !openQualificationCall && !openSubflows;*/
	}

	sendInvoice() {
		let orderLineIdsToInvoice = this.orderLines.filter(op => op.sendInvoice).map(orderLine => orderLine.id!);
		this.saleService.invoiceOrderLines(orderLineIdsToInvoice, this.taskAction!.id!).then(() => {
			this.sendInvoiceButton!.succeeded();
			this.orderLines.forEach(orderLine => {
				if (orderLine.sendInvoice) {
					orderLine.sendInvoice = false;
					orderLine.invoiced = new Date();
				}
			});
		});
	}

	canSendInvoice() {
		return this.orderLines.some(op => op.sendInvoice && op.invoiced == null);
	}
}
